import React from "react";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import type { RoomInfo as RoomInfoType } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import { useApacHotelsStyles } from "../../hooks";
import { ApacHotelsComponent } from "../../types";
import { DescriptionDialog } from "../DescriptionDialog";
import defaultStyles from "./styles.module.scss";
export interface RoomInfoProps extends RoomInfoType {
  amenitiesDialogTitle?: string;
  closeDialogText?: string;
}
export const RoomInfo: React.FC<RoomInfoProps> = ({
  name,
  amenities,
  description,
  sizeSqFt,
  amenitiesDialogTitle,
  closeDialogText,
  beds: { description: bedDescription },
}) => {
  const { t } = useI18nContext();
  const COMPONENT_KEY = ApacHotelsComponent.RoomInfo;
  const styles = useApacHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={block}>
      <span className={cn("title")}>{name}</span>
      <div className={cn("bed-info")}>
        <Icon className={cn("icon")} iconName={IconNameEnum.bed} />
        <span>{bedDescription}</span>
      </div>

      {sizeSqFt != null && (
        <div className={cn("room-size")}>
          <Icon className={cn("icon")} iconName={IconNameEnum.hotel} />
          <span>
            {t("hotelShop.hotelCard.roomSizeSquareFeet", { size: sizeSqFt })}
          </span>
        </div>
      )}

      {!!amenities?.length && (
        <div className={cn("amenities")}>
          <DescriptionDialog
            amenities={amenities}
            description={description ?? ""}
            title={amenitiesDialogTitle}
            closeDialogText={closeDialogText}
          />
        </div>
      )}
    </div>
  );
};
